/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Spaces_Modular_Wizard_Connection_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose what this space syncs from {provider}." |
*
* @param {Spaces_Modular_Wizard_Connection_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_connection_description = /** @type {((inputs: Spaces_Modular_Wizard_Connection_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Connection_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wähle aus, was dieser Space aus ${i?.provider} synchronisiert.`)
	return /** @type {LocalizedString} */ (`Choose what this space syncs from ${i?.provider}.`)
});